module.exports = __webpack_public_path__ + "../resources/img/ic_history_default.f4cd7b4f.svg";